<div class="tools_page" style="overflow:hidden;">
    <div class="tools_heading">
        Precision Tools to <br>Dominate the <span style="color: #ff600f;">Digital Space</span>
    </div>
    <div class="row tools_content">
        <div *ngFor="let tool of tools" class="col-md-3 " style="margin-bottom:50px ;">
            <div class="tool_card1 mat-elevation-z4" >
                <div class="col-md-3 tools_image">
                    <img [src]="tool.image" alt="tools" style="width:30px;height: 30px;">
                </div>
            </div>
            <mat-card style="height: 100%;" class="mat-elevation-z4" >
                <div class="col-md-9 tools_matter">
                    <div class="tool_title">{{tool.title}}</div>
                    <div class="tool_description">{{tool.description}}</div>
                </div>
            </mat-card>
        </div> 
    </div>
</div>